<template>
  <div></div>
</template>

<script>
import { wxWorkOAuthEntryApi, wxOAuthEntryApi } from "@/api";
import { setToken } from "@/utils/auth.js";
import Config from "@/config";
import { isPureWeChat, isWxWork } from "@/utils";

function parseAllQueryParams(url) {
  // 创建URL对象解析主URL
  const urlObj = new URL(url);
  const result = {};

  // 解析主URL的查询参数 (code, state)
  urlObj.searchParams.forEach((value, key) => {
    result[key] = value;
  });

  // 解析Hash路由中的查询参数
  const hash = urlObj.hash;
  if (hash.includes("?")) {
    const hashQueryString = hash.split("?")[1];
    const hashParams = new URLSearchParams(hashQueryString);

    hashParams.forEach((value, key) => {
      // 注意：如果主URL和hash中有同名参数，hash中的值会覆盖主URL的值
      result[key] = decodeURIComponent(value);
    });
  }

  return result;
}

export default {
  name: "Auth",
  data() {
    return {};
  },
  created() {
    this.$store.state.readyState = 0
    this.authUser();
  },
  methods: {
    authUser() {
      const { code } = parseAllQueryParams(location.href);
      if (!code) return;
      if (Config.isDevelopment) {
        this.debugAuth(code);
        return;
      }
      if (isWxWork) {
        this.wxWorkAuth(code);
        return;
      }
      if (isPureWeChat) {
        this.wxAuth(code);
        return;
      }
    },
    wxWorkAuth(code) {
      return wxWorkOAuthEntryApi({
        grantType: "wecom",
        loginType: "web",
        scope: "snsapi_privateinfo",
        clientId: this.$route.query.clientId,
        code: code,
      }).then((res) => {
        if (res.data.access_token) {
          setToken(res.data.access_token);
        }
        this.jumpRedirect()
      });
    },
    jumpRedirect(){
      const { origin, pathname } = location
      location.href = `${origin}${pathname}#${this.$route.query.redirect || '/'}`
    },
    wxAuth(code) {
      return wxOAuthEntryApi({
        grantType: "wechat",
        loginType: "web",
        clientId: this.$route.query.clientId,
        code: code,
      }).then((res) => {
        if (res.data.access_token) {
          setToken(res.data.access_token);
        }
        this.jumpRedirect()
      });
    },
    debugAuth(code) {
      if (this.$route.query.clientId && this.$route.query.type !== "wechat") {
        this.wxWorkAuth(code);
      } else {
        this.wxAuth(code).then(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
